import web3 from "web3";
import { Networks } from "../constants/blockchain";

const switchRequest = () => {
    return (window as any).ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: web3.utils.toHex(Networks.POLYGON_TEST) }],
    });
};

const addChainRequest = () => {
    return (window as any).ethereum.request({
        method: "wallet_addEthereumChain",
        params: [
            {
                chainId: web3.utils.toHex(Networks.POLYGON_TEST),
                chainName: "Mumbai Testnet",
                rpcUrls: ["https://rpc-mumbai.maticvigil.com/"],
                blockExplorerUrls: ["https://polygonscan.com/"],
                nativeCurrency: {
                    name: "MATIC",
                    symbol: "MATIC",
                    decimals: 18,
                },
            },
        ],
    });
};

export const swithNetwork = async () => {
    if (window.ethereum) {
        try {
            await switchRequest();
        } catch (error: any) {
            if (error.code === 4902) {
                try {
                    await addChainRequest();
                    await switchRequest();
                } catch (addError) {
                    console.log(error);
                }
            }
            console.log(error);
        }
    }
};
